/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".geopromo-row[_ngcontent-%COMP%]{background-position:bottom right;background-repeat:no-repeat;padding-left:30px}.geopromo-container[_ngcontent-%COMP%]{margin:auto;padding-top:10px}\n/*# sourceMappingURL=promo-list.component.css.map*/"];
export { styles as styles };
